import { useCallback } from 'react';

import type { NumericFormatProps } from 'react-number-format';
import { NumericFormat } from 'react-number-format';

import { Input } from './input';
import type { InputProps } from './type';

import { FormControl, FormItem, FormMessage } from '../form';

export type FormNumberInputProps = NumericFormatProps<InputProps> & {
  formItemClassName?: string;
  hideMsg?: boolean;
  ref?: React.Ref<HTMLInputElement>;
};

export const FormNumberInput = ({
  ref,
  formItemClassName,
  onValueChange,
  value,
  hideMsg = false,
  ...props
}: FormNumberInputProps) => {
  const changeHandler = useCallback<Required<NumericFormatProps>['onValueChange']>(
    (s, source) => {
      if (s.value !== value && !props.disabled) {
        onValueChange?.(s, source);
      }
    },
    [onValueChange, props.disabled, value]
  );

  return (
    <FormItem className={formItemClassName}>
      <FormControl>
        <div>
          <NumericFormat {...props} value={value} onValueChange={changeHandler} customInput={Input} getInputRef={ref} />
        </div>
      </FormControl>
      {!hideMsg && <FormMessage />}
    </FormItem>
  );
};
